import { Injectable, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2'

@Injectable({
  providedIn: 'root',
})
export class IdleService {
  private timeoutId: any;
  private idleTime: number = 10 * 60 * 1000; // 10 minutes in milliseconds
  // private idleTime: number = 10 * 1000; // 60 seconds

  constructor(private router: Router, private ngZone: NgZone, private route: ActivatedRoute) { }

  startMonitoring() {
    let expired = sessionStorage.getItem('sessionExpired')
    if (expired == 'true') {

      sessionStorage.clear();


      setTimeout(() => {
        window.location.href = '/login'
      }, 100)
      return;
    }
    sessionStorage.setItem('sessionExpired', 'false')
    this.resetTimer(); // Start the timer when the service is activated

    // Listen for user activity events
    this.ngZone.runOutsideAngular(() => {
      window.addEventListener('mousemove', this.resetTimer.bind(this));
      window.addEventListener('keydown', this.resetTimer.bind(this));
      window.addEventListener('click', this.resetTimer.bind(this));
      window.addEventListener('scroll', this.resetTimer.bind(this));
    });
  }

  private resetTimer() {
    if (window.location.pathname.includes('login') || window.location.pathname == '/') {
      return;
    }
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
    console.log('new timer')
    const timeout: any = parseInt(sessionStorage.getItem('sessionTimeOut') ?? '10');
    this.timeoutId = setTimeout(() => this.logout(), isNaN(timeout) ? (10 * 60 * 1000) : (timeout * 60 * 1000));
  }

  private logout() {

    sessionStorage.setItem('sessionExpired', 'true')
    console.log('User has been logged out due to inactivity');

    Swal.fire({
      title: 'Session Timeout',
      text: 'Your session has been expired due to inactivity. Click OK to log in again.',
      allowEscapeKey: false,
      allowOutsideClick: false,
      customClass: {
        container: 'heavy-blur-swal'
      },
      backdrop: true
    }).then((isConfirmed: any) => {
      if (isConfirmed) {

        sessionStorage.clear();

        setTimeout(() => {
          window.location.href = '/login'
        }, 100)
      }
    })
  }

  ngOnInit() {
  }
}
